import { render, staticRenderFns } from "./CreateViewConfigurationDialog.vue?vue&type=template&id=89eb8928&scoped=true&"
import script from "./CreateViewConfigurationDialog.vue?vue&type=script&lang=ts&"
export * from "./CreateViewConfigurationDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89eb8928",
  null
  
)

export default component.exports